import type { Food } from '~/data/nutrition'

/**
 * A food as it is named wherever it is named — "Oat cake by Biscuiteers" — the nutrition spec,
 * Logging an entry. Whose a food is belongs to what it is called rather than to the line of
 * figures under it: two tins of chopped tomatoes are two different things, and the name alone
 * has them both reading the same.
 *
 * The brand is drawn in the muted ink, so the two are read as one line and still not as one
 * name. Nothing is added where nothing is known — "by" trailing off into a space would be a
 * worse row than the name on its own.
 */
export function FoodName({ food }: { food: Pick<Food, 'name' | 'brand'> }) {
  return (
    <>
      {/*
        Isolated, both of them. A name written right to left beside words written left to right
        is one run of text as far as the browser is concerned, and it reorders the whole run to
        suit the direction it decides the run has — which is how "חלב 1% · 200 g" comes out as
        "200 · 1% חלב g". Isolating each piece says they are two runs, and each keeps its own
        direction inside the line without pulling the other around.
      */}
      <bdi>{food.name}</bdi>
      {food.brand !== null && food.brand !== '' && (
        <span className="text-ink-muted">
          {' by '}
          <bdi>{food.brand}</bdi>
        </span>
      )}
    </>
  )
}
